import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import css from '../css/lpview.m.css';

export interface LPViewProperties {
	classes?: string[];
	view: string;
	element?: string;
	kids: LPKidType[];
}

export interface LPKidType {
	widget: string;
	name?: string;
	element?: string;
	jsondata?: string;
	data?: any;
	topicroot?: string;
	kids?: LPKidType[];
}

const factory = create({ theme }).properties<LPViewProperties>();

export const LPView = factory(({ properties, middleware: { theme } }) => {
	const render_kids = (kids: LPKidType[]): DNode[] => {
		return kids.map((kid) => {
			const { widget, jsondata } = kid;
			const params: Partial<LPKidType> = { ...kid };
			delete params['widget'];
			if (jsondata) {
				params['data'] = JSON.parse(jsondata);
				delete params['jsondata'];
			}
			return w(widget, { ...params });
		});
	};

	const { classes = [], view, element = 'div', kids } = properties();
	const themeCss = theme.classes(css);

	return v(element, { key: view, xqa: `lpview ${view}`, classes: [themeCss.root, ...classes] }, render_kids(kids));
});

export default LPView;
